import { RoutesComponent } from './Routes'

export default RoutesComponent
